import React from 'react';

export default function AboutSection({ about }) {
  if (!about) return null;

  return (
    <div className="containers-min mx-auto px-4 pb-12">
      <h3 className="font-gilroy mb-4">About the Event</h3>
      <p className="font-poppins text-lg text-black/80 leading-relaxed">{about}</p>
    </div>
  );
}
